import { SortByTypeEnum } from "../../enums/list-layout/sort-type-enum";

export class EmitSortModel {
    sortSelected: SortByTypeEnum = SortByTypeEnum.None; 
    fieldName: string|undefined;

    constructor(sortSelected: SortByTypeEnum, fieldName: string |undefined){
        this.sortSelected = sortSelected;
        this.fieldName = fieldName;
    }
}
